import { render, staticRenderFns } from "./ClienteDialog.vue?vue&type=template&id=46d47552&"
import script from "./ClienteDialog.vue?vue&type=script&lang=js&"
export * from "./ClienteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports